import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';

import { HealthResolver } from 'src/app/core/resolvers/healthAndLifestyle.resolver';
import { TestUIComponent } from './container/test-ui-component';
import { TestUIControlTypeOneComponent } from './components/ct1/test-ui-ct1-component';


const testUIRoutes: Routes = 
[
  {
    path: 'ctOne',
    component: TestUIControlTypeOneComponent,
  }
];

@NgModule({
  imports: [
    RouterModule.forChild(testUIRoutes)
  ],
  exports: [
    RouterModule
  ]
})

export class testUICompRouteModule { }
